import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HeaderDivider, LabelValue } from "components";
import { formatDate } from "utils";
import { Gender } from "api";
import { RegistrationJourneyState } from "journey";

export const PersonalDetails = ({
  candidateDetails,
}: {
  candidateDetails: NonNullable<RegistrationJourneyState["candidateDetails"]>;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <HeaderDivider text={t("details.personalInfoTitle")} sx={{ mb: 3 }} />
      <Grid container spacing={2} sx={{ mb: 8 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <LabelValue
            label={t("details.firstName.label")}
            value={candidateDetails.firstName}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <LabelValue
            label={t("details.secondName.label")}
            value={candidateDetails.middleName}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <LabelValue
            label={t("details.lastName.label")}
            value={candidateDetails.lastName}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <LabelValue
            label={t("details.gender.label")}
            value={Gender[candidateDetails.gender]}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <LabelValue
            label={t("details.dateOfBirth.label")}
            value={formatDate(candidateDetails.dateOfBirth)}
          />
        </Grid>
      </Grid>
    </>
  );
};
